import { Flex } from "@common/styles/reusable/Flex/Flex.styles";
import styled from "styled-components";

export const ReleasesPageWrap = styled(Flex)`
  min-width: 114.4rem;
  width: 114.4rem;
  display: flex;
  flex-direction: column;
  padding: 3.2rem;
  gap: 1.2rem;
  box-sizing: content-box;
`;
